import { makeStyles } from '@material-ui/core';

const styles = (theme) => ({
  modalHeader: {
    marginBottom: theme.spacing(6),
    fontSize: 40,
    fontWeight: 300,
    lineHeight: 1.2
  },
  modalContent: {
    lineHeight: 1.5,
    display: 'block'
  },
  btncontainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginRight: theme.spacing(8),
    marginTop: theme.spacing(8)
  },
  yesbtn: {
    padding: theme.spacing(1, 2),
    width: 144,
    height: 36
  },
  nobtn: {
    padding: theme.spacing(1, 2),
    width: 98,
    height: 36
  }
});

export default makeStyles(styles);
